"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleUpdateCorrelations = exports.handleSetTolerance = exports.handleSetMF = exports.handleSetCorrelations = exports.handleSetCorrelation = exports.handleDeleteCorrelation = void 0;
const immer_1 = require("immer");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const nmr_correlation_1 = require("nmr-correlation");
const FindUtilities_1 = require("../../../data/utilities/FindUtilities");
const RangesActions_1 = require("./RangesActions");
const ZonesActions_1 = require("./ZonesActions");
function handleUpdateCorrelations(draft) {
    const { data: spectra, correlations } = draft;
    draft.correlations = (0, nmr_correlation_1.buildCorrelationData)(spectra, {
        ...correlations.options,
        values: (0, cloneDeep_1.default)(correlations.values),
    });
}
exports.handleUpdateCorrelations = handleUpdateCorrelations;
//action
function handleSetMF(draft, action) {
    const state = (0, immer_1.original)(draft);
    const { data: spectra, correlations } = state;
    const { mf } = action.payload;
    // update of correlation data is needed only if the following is true
    if (correlations.options.mf === '' || correlations.options.mf !== mf) {
        draft.correlations = (0, nmr_correlation_1.buildCorrelationData)(spectra, {
            ...correlations.options,
            mf,
            values: (0, cloneDeep_1.default)(correlations.values),
        });
    }
}
exports.handleSetMF = handleSetMF;
//action
function handleSetTolerance(draft, action) {
    const state = (0, immer_1.original)(draft);
    const { data: spectra, correlations } = state;
    const { tolerance } = action.payload;
    draft.correlations = (0, nmr_correlation_1.buildCorrelationData)(spectra, {
        ...correlations.options,
        tolerance,
        values: (0, cloneDeep_1.default)(correlations.values),
    });
}
exports.handleSetTolerance = handleSetTolerance;
//action
function handleSetCorrelation(draft, action) {
    const state = (0, immer_1.original)(draft);
    const { correlations } = state;
    const { id, correlation, options } = action.payload;
    draft.correlations = (0, nmr_correlation_1.setCorrelation)(correlations, id, correlation);
    if (options) {
        draft.correlations = {
            ...draft.correlations,
            options: { ...draft.correlations.options, ...options },
        };
    }
    handleUpdateCorrelations(draft);
}
exports.handleSetCorrelation = handleSetCorrelation;
//action
function handleSetCorrelations(draft, action) {
    const { correlations, options } = action.payload;
    const state = (0, immer_1.original)(draft);
    let correlationsData = (0, cloneDeep_1.default)(state.correlations);
    for (const correlation of correlations) {
        correlationsData = (0, nmr_correlation_1.setCorrelation)(correlationsData, correlation.id, correlation);
    }
    draft.correlations = correlationsData;
    if (options) {
        draft.correlations = {
            ...draft.correlations,
            options: { ...draft.correlations.options, ...options },
        };
    }
    handleUpdateCorrelations(draft);
}
exports.handleSetCorrelations = handleSetCorrelations;
//action
function handleDeleteCorrelation(draft, action) {
    const { correlation, assignmentData } = action.payload;
    // delete all signals linked to the correlation
    for (const link of correlation.links) {
        const spectrum = (0, FindUtilities_1.findSpectrum)(draft.data, link.experimentID, false);
        if (spectrum) {
            if (spectrum.info.dimension === 1) {
                const range = (0, FindUtilities_1.findRange)(spectrum, link.signal.id);
                const signal = (0, FindUtilities_1.findSignal1D)(spectrum, link.signal.id);
                if (range && signal) {
                    (0, RangesActions_1.deleteSignal1D)(draft, {
                        spectrum,
                        range,
                        signal,
                        assignmentData,
                    });
                }
            }
            else if (spectrum.info.dimension === 2) {
                const zone = (0, FindUtilities_1.findZone)(spectrum, link.signal.id);
                const signal = (0, FindUtilities_1.findSignal2D)(spectrum, link.signal.id);
                if (zone && signal) {
                    (0, ZonesActions_1.deleteSignal2D)(draft, {
                        spectrum,
                        zone,
                        signal,
                        assignmentData,
                    });
                }
            }
        }
    }
}
exports.handleDeleteCorrelation = handleDeleteCorrelation;
